angular
  .module('LessonControllers', [])

  //config for /supports
  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider

        // lesson
        .when('/lesson', {
          templateUrl: '/ng1/www/modules/lesson/html/list.html',
          controller: 'LessonListCtrl'
        })
        .when('/cours', {
          templateUrl: '/ng1/www/modules/lesson/html/list.html',
          controller: 'LessonListCtrl'
        })
        .when('/lesson/:lessonId', {
          templateUrl: '/ng1/www/modules/lesson/html/detail.html',
          controller: 'LessonDetailCtrl'
        })
        .when('/cours/:lessonId', {
          templateUrl: '/ng1/www/modules/lesson/html/detail.html',
          controller: 'LessonDetailCtrl'
        });
    }
  ])
  .run([
    'secondNavbar',
    'exam',
    'nbModules',
    'EXAM',
    function(secondNavbar, exam, nbModules, EXAM) {
      nbModules.addModules(1);
      if (exam.examData.langForExercises === 'fr') {
        if (EXAM === 'lerobert') {
          secondNavbar.addModules('Règles', '/cours', 4);
        } else if (EXAM === 'delf') {
          secondNavbar.addModules(
            'Focus langue',
            '/cours',
            4,
            'navbar.focus_langue'
          );
        } else {
          secondNavbar.addModules('Cours', '/cours', 4);
        }
      } else {
        secondNavbar.addModules('Cours', '/lesson', 4);
      }
    }
  ]);
